import type { Btc15PredictorResponse } from '../../lib/btc15Types';
import { formatRelativeAge, formatTimestamp } from '../../lib/format';
import { isPredictorDataStale } from '../../lib/btc15DataAge';
import styles from './Btc15Diagnostics.module.css';

export function Btc15Diagnostics({ response }: { response: Btc15PredictorResponse }) {
  const stale = isPredictorDataStale(response);

  return (
    <details className={styles.details}>
      <summary className={styles.summary}>
        <span>Quote &amp; data diagnostics</span>
        {stale && <span className={styles.staleBadge}>STALE</span>}
      </summary>
      <div className={styles.body}>
        <div className={styles.row}>
          <span>Quote source</span>
          <span>{response.quote.source}</span>
        </div>
        <div className={styles.row}>
          <span>Quote latency</span>
          <span>{response.diagnostics.kalshiLatencyMs ?? '—'} ms</span>
        </div>
        <div className={styles.row}>
          <span>Coinbase candles (1m)</span>
          <span>{response.diagnostics.coinbaseCandleCount1m}</span>
        </div>
        <div className={styles.row}>
          <span>Coinbase data age</span>
          <span>{Math.round(response.diagnostics.coinbaseDataAgeMs / 1000)}s</span>
        </div>
        <div className={styles.row}>
          <span>Order book samples</span>
          <span>{response.diagnostics.orderBookSamples}</span>
        </div>
        <div className={styles.row}>
          <span>Order book spread</span>
          <span>{response.diagnostics.orderBookSpreadBps.toFixed(2)} bps</span>
        </div>
        {response.diagnostics.kalshiError && (
          <div className={`${styles.row} ${styles.error}`}>
            <span>Kalshi error</span>
            <span>{response.diagnostics.kalshiError}</span>
          </div>
        )}
        <p className={styles.timestamp}>
          Last complete update: {formatTimestamp(response.generatedAt)} (
          {formatRelativeAge(response.generatedAt)})
        </p>
      </div>
    </details>
  );
}
